import { render } from "./BlockProgressEdit.vue?vue&type=template&id=6ebf6a51"
import script from "./BlockProgressEdit.vue?vue&type=script&lang=js"
export * from "./BlockProgressEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__